import React from 'react'

interface ICustomDropDownProps {
    label: string;
    required?: boolean;
    onChange: (value: any) => void;
    value: string;
    touched: boolean;
    error: string | undefined;
    handleBlur: (e: React.FocusEvent<any>) => void;
    list: any;
    selectTitle?: string;
}

const CustomDropDownList = ({
    label,
    required = false,
    onChange,
    value,
    touched,
    error,
    selectTitle = 'Select an option',
    list,
    handleBlur
}: ICustomDropDownProps) => {
    return (
        <div className="w-full my-2">
            <div className="text-text_2 text-md font-semibold mb-2">
                {label}
            </div>
            <select
                id={label?.split(' ')?.join('').toLowerCase()}
                value={value}
                onChange={onChange}
                className="w-full border-2 p-2 rounded-lg focus:outline-none focus:border-secondary"
                onBlur={handleBlur}
            >
                <option value="">
                    {selectTitle}
                </option>
                {list?.map((district: { id: number, name: string }, index: number) => {
                    return (
                        <option key={index} value={district?.name}>
                            {district?.name}
                        </option>
                    )
                })}
            </select>
            {required && touched && error ? (
                <span className="text-error text-sm mt-1">
                    {error}
                </span>
            ) : null}
        </div>
    )
}

export default CustomDropDownList